import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessService } from 'app/core/services/access.service';

@Component({
  selector: 'dialog-delete-access',
  templateUrl: './dialog-delete-access.component.html',
  styleUrls: ['./dialog-delete-access.component.scss']
})
export class DialogDeleteAccessComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteAccessComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private accessService: AccessService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteAccess() {
    this.isLoading = true;
    this.accessService.deleteAdmin(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        window.location.reload();
        this.dialogRef.close();
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  deleteAccessSupervisor() {
    this.isLoading = true;
    this.accessService.deleteSupervisor(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        window.location.reload();
        this.dialogRef.close();
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  deleteAccessClient() {
    this.isLoading = true;
    this.accessService.deleteClientAccess(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        window.location.reload();
        this.dialogRef.close();
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }
}
